import React, { useEffect, createElement } from 'react';
import { TopBar } from './components/TopBar';
import { BrandHeader } from './components/BrandHeader';
import { Hero } from './components/Hero';
import { Identification } from './components/Identification';
import { Solution } from './components/Solution';
import { QueAprenderas } from './components/QueAprenderas';
import { Benefits } from './components/Benefits';
import { TestimoniosSistema } from './components/TestimoniosSistema';
import { PreguntasFrecuentes } from './components/PreguntasFrecuentes';
import { MasterFinalCTA } from './components/MasterFinalCTA';
import { StickyBuyBar } from './components/StickyBuyBar';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1100702405600602');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1100702405600602&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-brand-white font-sans text-brand-text selection:bg-brand-gold/30" data-id="element-0">
      <TopBar data-id="element-1" />
      <BrandHeader data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Identification data-id="element-5" />
        <Solution data-id="element-6" />
        <QueAprenderas data-id="element-7" />
        <Benefits data-id="element-8" />
        <TestimoniosSistema data-id="element-9" />
        <PreguntasFrecuentes data-id="element-10" />
        <MasterFinalCTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
      <StickyBuyBar data-id="element-13" />
    </div>;
}